var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { active: _vm.isVisible, "popup-overlay": 1 } }, [
    _c("div", { staticClass: "popup-dialog mybaumit-dialog" }, [
      _c("div", { staticClass: "close", on: { click: _vm.close } }, [
        _vm._v("×")
      ]),
      !_vm.FPassword
        ? _c("div", [
            _c("form", [
              _c("h3", [_vm._v(_vm._s(_vm.trans("login")))]),
              _c("div", { staticClass: "inputs" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      name: "email",
                      type: "email",
                      placeholder: _vm.trans("form_email")
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  }),
                  _c("div", { staticClass: "validation-error" }, [
                    _vm._v(_vm._s(_vm.errors.first("email")))
                  ])
                ]),
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:3",
                        expression: "'required|min:3'"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "password",
                      name: "password",
                      placeholder: _vm.trans("form_pwd")
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      }
                    }
                  }),
                  _c("div", { staticClass: "validation-error" }, [
                    _vm._v(_vm._s(_vm.errors.first("password")))
                  ])
                ])
              ]),
              _c("div", { staticClass: "error" }, [
                _vm._v(_vm._s(_vm.backendMessage))
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-start align-items-center mt-3"
                },
                [
                  _c("p", { staticClass: "bodytext m-0" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button-style",
                        on: {
                          click: function($event) {
                            return _vm.pwRecShow()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.trans("login_forgot")))]
                    )
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "button type-2 ml-auto",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.sendLogin()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.trans("button_login")))]
                  )
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm.FPassword && !_vm.SuccessPWRec
        ? _c("div", [
            _c("form", [
              _c("h3", [_vm._v(_vm._s(_vm.trans("login_forgotten_pwd")))]),
              _c("p", [
                _vm._v(_vm._s(_vm.trans("login_forgotten_pwd_inputinfo")))
              ]),
              _c("div", { staticClass: "inputs" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "email",
                      name: "recovery_email",
                      placeholder: _vm.trans("form_email")
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "error" }, [
                _vm._v(_vm._s(_vm.recPWError))
              ]),
              _c("div", { staticClass: "clearfix" }, [
                _c(
                  "button",
                  {
                    staticClass: "button type-2 pull-right",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.sendPWRec()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.trans("button_submit")))]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm.FPassword && _vm.SuccessPWRec
        ? _c("div", [
            _c("h3", { staticClass: "mb-3" }, [
              _vm._v(_vm._s(_vm.trans("login_forgotten_pwd")))
            ]),
            _c("p", [
              _vm._v(_vm._s(_vm.trans("login_forgotten_pwd_successinfo")))
            ]),
            _c(
              "button",
              {
                staticClass: "button type-2 pull-right",
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.trans("button_close")))]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }